import { IdResource } from "../../../../../constants/IdResource";
export var checkIsResourceToSpendDecoCoupons = function (path) { return function (action, state$, dependencies) {
    var isResourceToSpendCoupons = action.taskType &&
        action.taskType.resourceId &&
        action.taskType.resourceId === IdResource.DecoCoupons;
    return isResourceToSpendCoupons ? path : undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/quest-tasks/spend-resource/checks/checkIsResourceToSpendDecoCoupons.ts
// module id = 2383
// module chunks = 3